import { UserSettingConfig } from '@benzinga/user-settings';
import { AllProUserSetting, ProUserSetting, ProUserSettingsVersion } from './entities';

const loader: (typeof ProUserSettingConfig)['loader'] = (setting, allSettings): ProUserSetting => {
  if (setting == null || !('version' in setting)) {
    return loader(
      {
        autoFocusOnTickerHover: true,
        chatGuidelinesAcceptedAt: null,
        colorBlindMode: 'none',
        hotkeysEnabled: true,
        infoBarEnabled: true,
        initialMorningUpdateLoad: false,
        notificationsEnabled: true,
        onBoardingModalDismissCount: 0,
        opraModalMandatoryStartDate: '',
        showTickerHover: true,
        sidebarVisible: true,
        timeFormat: 'AM/PM',
        timezone: 'America/New_York',
        trialEndingBannerDismissed: false,
        version: 1,
      },
      allSettings,
    );
  }

  switch (setting.version) {
    case 1:
      return {
        ...setting,
        chatGuidelinesAcceptedAt: setting.chatGuidelinesAcceptedAt ?? null,
        onBoardingModalDismissCount: setting.onBoardingModalDismissCount ?? 0,
        showTickerHover: setting.showTickerHover ?? true,
        trialEndingBannerDismissed: setting.trialEndingBannerDismissed ?? false,
      };
  }
};

export const ProUserSettingConfig: UserSettingConfig<
  'pro-settings',
  ProUserSettingsVersion,
  ProUserSetting,
  AllProUserSetting
> = {
  key: 'pro-settings',
  loader,
  version: 1,
};
